import React from "react";
import CommonButtons from "../../../../../../shared/components/CommonButtons";
import Print from "../../../../../../printConfigration/PrintConfigration";
import PaymentMethods from "./PaymentMethods";
import { hasPermission } from "src/shared/components/PermissionRoute";
import usePermission from "src/business-types/grocery/hooks/usePermission";
import { PERMISSIONS, useCheckPermission } from "src/permissionCheck/PermossionChick";

interface Props {
  ffamilys: string;
  droupdown: () => React.ReactNode;
  showPaymentMethods: boolean;
  remaining: () => number;
  outstangingamount: () => number;
  payments: () => void;
  getorder: any;
  setOpenCancelDialog: (val: boolean) => void;
  printData: any;
  filteredCustomerId: string | number;
  COMPLETE: { Blue: string; name: string };
  paylate: boolean;
  cashpay: boolean;
  setpaylate: React.Dispatch<React.SetStateAction<boolean>>;
  setcashpay: React.Dispatch<React.SetStateAction<boolean>>;
  setpaycard: React.Dispatch<React.SetStateAction<boolean>>;
  paycard: boolean;
}

const OrderPaymentMethods: React.FC<Props> = ({ ffamilys, droupdown, showPaymentMethods, remaining, outstangingamount, payments, getorder, setOpenCancelDialog, printData, filteredCustomerId, COMPLETE, paylate, cashpay, setpaylate, setcashpay, paycard, setpaycard
}) => {
  const isPaymentMethodSelected = paylate || cashpay || paycard;
  const isCompleteEnabled = remaining() > 0 ? isPaymentMethodSelected : true;
  const { checkPermission } = useCheckPermission()
  const cancelOrder = checkPermission(PERMISSIONS.ORDER.CANCEL)

  return (
    <div className="w-full" style={{ fontFamily: ffamilys }}>
      {/* Dropdown */}
      <div className="w-full pl-1 pr-1">{droupdown()}</div>

      {/* Payment Methods */}
      {showPaymentMethods && (
        <div className="w-full">
          <div className="text-[16px] bg-gray-200 font-bold py-1 px-2 rounded">Payment methods</div>

          <div className="flex flex-col gap-2 p-2 border-2 border-dotted border-black rounded-md mt-2">
            {remaining() === 0 || outstangingamount() <= 0 ? (
              <p className="text-sm sm:text-base"> You have no remaining balance for this order. <br /> Please change the order status to <b>"Delivered"</b>. </p>
            ) : (
              <>
                <PaymentMethods
                  paylate={paylate}
                  cashpay={cashpay}
                  setpaylate={setpaylate}
                  setcashpay={setcashpay}
                  paycard={paycard}
                  setpaycard={setpaycard}
                />

                <div className="w-full flex justify-center mt-1">
                  <CommonButtons className="h-10 w-full sm:w-44" label="COMPLETE" disabled={!isCompleteEnabled} onClick={payments} />
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* Bottom buttons */}
      <div className="flex flex-col sm:flex-row justify-around items-center gap-3 sm:gap-0 space-y-1 pb-2 mt-4 sm:mt-2 w-full">

        {cancelOrder && <CommonButtons
          className="h-10 w-full sm:w-40"
          label="CANCEL ORDER"
          variant="danger"
          disabled={getorder?.OrderStatus === "Delivered" || getorder?.OrderStatus === "Cancelled"}
          onClick={() => setOpenCancelDialog(true)}
        />}

        {getorder?.OrderStatus !== "Cancelled" && (<div className="mt-2 sm:mt-0">
          <Print PrintData={{ ...printData, Paid: printData.Paid ?? 0, clientId: filteredCustomerId ?? "0", }} BtnName="PRINT RECEIPT" username="" />
        </div>
        )}
      </div>
    </div>
  );
};

export default OrderPaymentMethods;
